export const AVAILABLE_LANGUAGES = ["de", "en"];